export default __webpack_public_path__ + "static/media/confirmed.a7a85530.svg";